import React from 'react';
import classNames from "classnames";
// material-ui components
import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

import styles from "assets/jss/components/customSelect.js";

const useStyles = makeStyles(styles);

export default function CustomSelect(props) {
  const classes = useStyles();
  const {
    formControlProps,
    labelText,
    id,
    labelProps,
    error,
    success,
    selectProps,
    data,
    valueField,
    textField,
    helperText
  } = props;

  const labelClasses = classNames({
    [" " + classes.labelRootError]: error,
    [" " + classes.labelRootSuccess]: success && !error
  });

  return (
    <FormControl
      fullWidth={true}
      {...formControlProps}
      className={classes.formControl + " " + (formControlProps ? formControlProps.className : null)}
    >
      {labelText !== undefined ? (
        <InputLabel
          className={classes.labelRoot + labelClasses}
          htmlFor={id}
          {...labelProps}
        >
          {labelText}
        </InputLabel>
      ) : null}
      <Select
        MenuProps={{
          className: classes.selectMenu
        }}
        {...selectProps}
      >
        {data.map((prop,key)=>{
          return <MenuItem
            classes={{
              root: classes.selectMenuItem,
              selected: classes.selectMenuItemSelected,
            }}
            key={key}
            value={typeof prop === "object" ? prop[valueField] : prop}
          >
            {typeof prop === "object" ? prop[textField] : prop}
          </MenuItem>
        })}
      </Select>
      { helperText ? <FormHelperText>{helperText}</FormHelperText> : null }
    </FormControl>
  );
}
